import React, { useContext, useEffect } from 'react';
import { IRestaurantsContext, RestaurantsContext } from '../../../restaurantsState/restaurantsContext';
import { IGetCities, UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { useFetchData } from 'hooks/useFetchData';
import { getCities } from 'backend/additionalInformation';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import style from './CitySelect.module.scss';

const CitySelect: React.FC = () => {
	const { setIDCity, IDSelectedCountry, IDSelectedCity } = useContext<IRestaurantsContext>(RestaurantsContext);
	const hasAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const { response, loading, refetch, responseError } = useFetchData<IGetCities, string>(
		IDSelectedCountry && hasAccess ? getCities : null,
		IDSelectedCountry || '',
	);

	const value = IDSelectedCountry && !loading ? IDSelectedCity : undefined;

	const handleSelect = (value: string) => {
		setIDCity(value);
	};

	useEffect(() => {
		refetch();
	}, [IDSelectedCountry]);

	return (
		<OutsideFormSelect
			containerClassName={style.container}
			className={style.select}
			testId="CitySelect"
			name="CitySelect"
			label="cityLabel"
			onChange={handleSelect}
			onRefetch={refetch}
			value={value}
			options={response?.data.cities}
			listItemHeight={response?.data.cities.length}
			disabled={!IDSelectedCountry || !hasAccess || loading}
			loading={loading}
			fetchError={responseError}
			withValidation={false}
		/>
	);
};

export default CitySelect;
